export default __webpack_public_path__ + "static/project-calendar-503e14a1259ad9fa75aba216f428ba5c.png";